import { User } from "./user.model";

export interface IligaAccount {
    id: number,
    firstName?: string,
    lastName?: string,
    middleName?: string,
    internalName?: string,
    birthDate?: Date,
    contractStartDate?: Date,
    contractEndDate?: Date,
    medicalBookDate?: Date,
    user?: User
}

export class ligaAccount implements IligaAccount {
    constructor(
        public id: number,
        public firstName?: string,
        public lastName?: string,
        public middleName?: string,
        public internalName?: string,
        public birthDate?: Date,
        public contractStartDate?: Date,
        public contractEndDate?: Date,
        public medicalBookDate?: Date
    ) { }
}
